import type { ButtonHTMLAttributes, HTMLAttributes } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { XCloseIcon } from '@/components/ui/icons'
import { cn } from '@/helpers/utils'

/**
 * @deprecated Use Dialog instead
 */
export const ModalHeader = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'grid grid-cols-3 items-center px-2.5 py-2 text-center font-bold text-neutral-900 [&_h3]:whitespace-nowrap [&_h3]:text-sm',
			className
		)}
		{...props}
	/>
)
/**
 * @deprecated Use Dialog instead
 */
export const ModalBody = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'flex h-full flex-col gap-6 overflow-auto p-6',
			className
		)}
		{...props}
	/>
)
/**
 * @deprecated Use Dialog instead
 */
export const ModalFooter = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'flex justify-between border-neutral-200 border-t px-6 py-4',
			className
		)}
		{...props}
	/>
)
/**
 * @deprecated Use Dialog instead
 */
export const ModalTitle = ({
	className,
	...props
}: HTMLAttributes<HTMLHeadingElement>) => (
	<h3
		className={cn('font-medium text-xl [&_b]:font-bold', className)}
		{...props}
	/>
)
/**
 * @deprecated Use Dialog instead
 */
export const ModalParagraph = ({
	className,
	...props
}: HTMLAttributes<HTMLParagraphElement>) => (
	<p className={cn('text-sm', className)} {...props} />
)
/**
 * @deprecated Use Dialog instead
 */
export const ModalXCloseButton = (
	props: ButtonHTMLAttributes<HTMLButtonElement>
) => (
	<ButtonLegacy shape='square' type='button' variant='tertiary' {...props}>
		<XCloseIcon />
	</ButtonLegacy>
)
